import {
  Avatar,
  Box,
  Collapse,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import React, { Fragment } from "react";
import { firebaseDateToDateTime } from "../../../utilities/firebaseDateToDateTime";
import SquishedDate from "../../SquishedDate";

export default function EventListItem({ label, event }) {
  //state for open
  const [open, setOpen] = React.useState(false);

  const name = event.name;
  const image = event.image;
  const description = event.description;
  const timeDateActioned = firebaseDateToDateTime(event.timeDateActioned);
  // const date = event.date;

  return (
    <Fragment>
      <ListItem
        key={name}
        style={{
          cursor: "pointer",
          padding: 0,
          //   backgroundColor: isSelected ? "#e0e0e0" : "white",
        }}
        secondaryAction={<SquishedDate date={timeDateActioned} />}
        onClick={() => setOpen(!open)}
      >
        <ListItemAvatar>
          <Avatar src={image} alt={name} />
        </ListItemAvatar>
        <ListItemText primary={label} secondary={name} />
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ margin: 1 }} onClick={() => setOpen(!open)}>
          <Typography variant="body1">{description}</Typography>
        </Box>
      </Collapse>
    </Fragment>
  );
}
